/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entries_EmptyInputs */

const th_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีทีมเข้าร่วม`)
};

const en_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No teams entered yet.`)
};

const ja_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参加チームはまだありません。`)
};

const zh_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚无球队报名。`)
};

const es_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay equipos inscritos.`)
};

const pt_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum time inscrito ainda.`)
};

const id_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada tim yang mendaftar.`)
};

const fr_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune équipe inscrite pour l’instant.`)
};

const tl_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang team na sumali.`)
};

const vi_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có đội nào đăng ký.`)
};

const ko_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 등록한 팀이 없습니다.`)
};

const de_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Teams gemeldet.`)
};

const ru_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ни одна команда ещё не заявилась.`)
};

const tr_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz kaydolan takım yok.`)
};

const it_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna squadra iscritta.`)
};

const pl_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie zgłosiła się jeszcze żadna drużyna.`)
};

const uk_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жодна команда ще не заявилася.`)
};

const hi_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी किसी टीम ने पंजीकरण नहीं कराया।`)
};

const ar_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يسجّل أي فريق بعد.`)
};

const ms_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada pasukan mendaftar.`)
};

const bn_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখনও কোনও দল নিবন্ধন করেনি।`)
};

const zh_tw2_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無球隊報名。`)
};

const zh_hk2_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無球隊報名。`)
};

const ur_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابھی کسی ٹیم نے رجسٹر نہیں کیا۔`)
};

const fa_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز تیمی ثبت‌نام نکرده است.`)
};

const sw_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna timu iliyojisajili bado.`)
};

const nl_entries_empty = /** @type {(inputs: Entries_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen teams ingeschreven.`)
};

/**
* | output |
* | --- |
* | "No teams entered yet." |
*
* @param {Entries_EmptyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const entries_empty = /** @type {((inputs?: Entries_EmptyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entries_EmptyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_entries_empty(inputs)
	if (locale === "ja") return ja_entries_empty(inputs)
	if (locale === "zh") return zh_entries_empty(inputs)
	if (locale === "es") return es_entries_empty(inputs)
	if (locale === "pt") return pt_entries_empty(inputs)
	if (locale === "id") return id_entries_empty(inputs)
	if (locale === "fr") return fr_entries_empty(inputs)
	if (locale === "tl") return tl_entries_empty(inputs)
	if (locale === "vi") return vi_entries_empty(inputs)
	if (locale === "ko") return ko_entries_empty(inputs)
	if (locale === "de") return de_entries_empty(inputs)
	if (locale === "ru") return ru_entries_empty(inputs)
	if (locale === "tr") return tr_entries_empty(inputs)
	if (locale === "it") return it_entries_empty(inputs)
	if (locale === "pl") return pl_entries_empty(inputs)
	if (locale === "uk") return uk_entries_empty(inputs)
	if (locale === "hi") return hi_entries_empty(inputs)
	if (locale === "ar") return ar_entries_empty(inputs)
	if (locale === "ms") return ms_entries_empty(inputs)
	if (locale === "bn") return bn_entries_empty(inputs)
	if (locale === "zh-TW") return zh_tw2_entries_empty(inputs)
	if (locale === "zh-HK") return zh_hk2_entries_empty(inputs)
	if (locale === "ur") return ur_entries_empty(inputs)
	if (locale === "fa") return fa_entries_empty(inputs)
	if (locale === "sw") return sw_entries_empty(inputs)
	if (locale === "nl") return nl_entries_empty(inputs)
	return en_entries_empty(inputs)
});